
import Cookies from 'js-cookie';
import auth from '../../api/auth';

const cUser = Cookies.get('user') || '';
const cToken = Cookies.get('token') || '';
const cStaff = Cookies.get('staff') || '';
const cUerID = 912;

const account = {
  state: {
    user: cUser,
    token: cToken,
    staff: cStaff,
    userID: cUerID,
  },
  mutations: {
    SET_USER: (state, user) => {
      Cookies.set('user', user, { expires: 30 });
      state.user = user;
    },
    SET_STAFF: (state, staff) => {
      Cookies.set('staff', staff, { expires: 30 });
      state.user = staff;
    },
    SET_LOGOUT: (state) => {
      // Cookies.remove('token', { domain: 'tsay.qq.com' });
      Cookies.remove('token');
      state.token = '';
    },
    SET_TOKEN: (state, token) => {
      // Cookies.set('token', token, { expires: 30, domain: 'tsay.qq.com' });
      Cookies.set('token', token, { expires: 30 });
      state.token = token;
    },
  },
  actions: {
    async login({ commit }, { username, password, callback }) {
      commit('SET_USER', username);
      const res = await auth.login({ username, password });
      if (res && res.errno === 0 && res.data.token) {
        commit('SET_TOKEN', res.data.token);
        commit('SET_STAFF', res.data.staff);
      }
      callback(res);
    },
    setRouter({ commit }, url) {
      commit('SET_ROUTER', url);
    },
    setUser({ commit }, obj) {
      commit('SET_USER', obj);
    },
    setLogout({ commit }) {
      commit('SET_LOGOUT');
    },
  },
  getters: {
    accountUser: state => state.user,
    accountToken: state => state.token,
    accountRtx: state => state.staff,
    courseUserID: state => state.userID,
  },
};

export default account;
